<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<div class="card-title">课程分类管理</div>
			<el-divider></el-divider>
			<div class="row-me row-center">
				<div class="row-me row-center">
					<div class="left-title">一级分类名称：</div>
					<div class="width300">
					    <el-input placeholder="请输入" style="width: 100%;" clearable v-model="firstClassValue"></el-input>
					</div>
				</div>
				<div class="row-me row-center">
					<div class="left-title">版本：</div>
					<div class="width200">
					    <el-input placeholder="请输入" style="width: 100%;" clearable v-model="firstClassVersion"></el-input>
					</div>
				</div>
				<el-button class="margin-left20" type="danger" size="mini" @click="levelFirstClassAdd()">保存</el-button>
				<el-button class="margin-left20" type="primary" size="mini" @click="goToSubjectBindClass()">科目分类绑定</el-button>
			</div>
			<el-divider></el-divider>
			<div class="column-me flex1 overflow-auto">
				<el-tree :data="treeData" node-key="id" :expand-on-click-node="true">
					<template class="custom-tree-node" v-slot="{ node, data }">
					    <span style="width: 300px;">{{node.label}}</span>
					    <span>
							<el-button type="primary" size="small " @click="()=>append(data)">添加下级分类</el-button>
							<el-button type="success" size="small " @click="()=>editName(data)">修改</el-button>
							<el-button type="danger" size="small" @click="()=>remove(node, data)">删除</el-button>
					    </span>
					</template>
				</el-tree>
			</div>
		</div>
	</div>
	<!-- 分类信息添加界面 -->
	<el-dialog title="分类信息添加" v-model="addInfoBox" width="800px" top="10vh" :destroy-on-close="true">
	    <div class="padding-left0">
			<div class="row-me row-center margin-top20" :v-model="parentCategoryBox">
				<div class="left-title"><span class="red-star">*</span>上级分类：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="parentCategory" :disabled="true"></el-input>
				</div>
			</div>
	        <div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>分类名称：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.name"></el-input>
				</div>
	        </div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>版本：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.version" :disabled="true"></el-input>
				</div>
			</div>
	        <div class="row-me flex-end1 margin-top50">
				<el-button @click="closeAddInfoBox()">取消</el-button>
				<el-button type="primary" @click="addInfoPost()">确定</el-button>
	        </div>
	    </div>
	</el-dialog>
	<!-- 分类信息修改界面 -->
	<el-dialog title="分类信息修改" v-model="editInfoBox" width="800px" top="10vh" :destroy-on-close="true">
	    <div class="padding-left0">
	        <div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>分类名称：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="editInfo.name" ></el-input>
				</div>
	        </div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>版本：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="editInfo.version" ></el-input>
				</div>
			</div>
	        <div class="row-me flex-end1 margin-top50">
				<el-button @click="closeEditInfoBox()">取消</el-button>
				<el-button type="primary" @click="editInfoPost()">确定</el-button>
	        </div>
	    </div>
	</el-dialog>
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
export default {
	components: {Plus,Search},
	data() {
		return {
			treeData:[],
			grade_id:0,
			firstClassValue:"",
			firstClassVersion:"",
			addInfoBox:false,
			editInfoBox:false,
			addInfo:{
				grade_id:'',
				name:'',
				version:''
			},
			editInfo:{
				id:'',
				name:'',
				version:''
			},
			parentCategory:'',
			parentVersion:'',
			parentCategoryBox:false,
		}
	},
	// 侦听器
	watch: {},
	// 计算属性
	computed: {
		Search() {
		return Search
		}
	},
	// html加载完成之前
	created() {
		this.getTreeData();
	},
	// html加载完成后执行。
	mounted() {

	},
	// 事件方法执行
	methods: {
		//跳转科目分类绑定界面
		goToSubjectBindClass() {
		    this.$router.push('/subjectBindClass');
		},
		//tree渲染
		loadNode(node, resolve) {
			console.log(node);
			if(node.level === 0){
				setTimeout(() => {
					resolve(this.treeData);
					console.log(this.treeData);
				}, 500);
			}
			if (node.level >= 1){
				this.grade_id = node.key;
				this.getTreeData();
				setTimeout(() => {
					resolve(this.treeData);
				}, 500);
			};
        },
		//添加一级分类
		levelFirstClassAdd(){
			if(this.firstClassValue == ''){
				this.$message({
				    message: '一级分类不可为空',
				    type: 'warning'
				});
				return
			}
			if(this.firstClassVersion == ''){
				this.$message({
				    message: '一级分类版本不可为空',
				    type: 'warning'
				});
				return
			}
			this.$post('/admin/specialSubAdd', {
				name: this.firstClassValue,
				version: this.firstClassVersion
			}).then((res) => {
				if (res) {
					this.firstClassValue = '';
					this.getTreeData();
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//添加下级分类
		append(data){
			console.log(data);
			this.addInfoBox = true;
			this.parentCategoryBox = true;
			this.parentCategory = data.name;
			this.parentVersion = data.version;
			this.addInfo.grade_id = data.id;
			this.addInfo.version = data.version;
			//console.log(this.addInfo);
		},
		//下级分类post提交
		addInfoPost(){
			// console.log(this.addInfo);
			// return;
			this.$post('/admin/specialSubAdd', this.addInfo).then((res) => {
				if (res) {
					this.addInfoBox = false;
					this.parentCategoryBox = false;
					this.$message.success('添加成功');
					this.addInfo = {
						grade_id:'',
						name:'',
						version:''
					};
					this.getTreeData();
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		closeAddInfoBox(){
			this.addInfoBox = false;
			this.getTreeData();
		},
		//删除分类
		remove(node, data){
			if(data.children.length != 0){
				this.$message.warning('请先删除下级分类！');
				return;
			}
			const parent = node.parent;
			const children = parent.data.children || parent.data;
			const index = children.findIndex(d => d.id === data.id);
			children.splice(index, 1);
			this.$confirm("您确定删除吗？删除后无法恢复！", "温馨提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.$post('/admin/specialSubDel', {
					id: data.id
				}).then((res) => {
					if (res) {
					    this.$message.success('删除成功')
					}
				}).catch((error) => {
					this.getTreeData();
				})
			}).catch((error) => {
				this.getTreeData();
			});	
		},
		editName(data){
			this.editInfoBox = true;
			this.editInfo.id = data.id;
			this.editInfo.name = data.name;
			this.editInfo.version = data.version;
		},
		//修改分类名称
		editInfoPost(){
			this.$post('/admin/specialSubAdd', this.editInfo).then((res) => {
				if (res) {
					this.editInfoBox = false;
					this.$message.success('修改成功');
					this.editInfo = {
						id:'',
						name:'',
						version:''
					};
					this.getTreeData();
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		closeEditInfoBox(){
			this.editInfoBox = false;
		},
		//获取下级分类
		getTreeData() {
			this.$post('/admin/specialSubList', {
				grade_id: this.grade_id
			}).then((res) => {
				if (res) {
					this.treeData = res.data;
					console.log(this.treeData);
					if(this.treeData.length == 0){
						this.$message({
						    message: '还未添加下级分类',
						    type: 'warning'
						});
					}
				}
			}).catch((error) => {
				console.log(error)
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.userList {
  height: 100%;

  .img-header {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
}
</style>
